import styled from 'styled-components';
import Stack from '../stack/stack';

export const SectionContent = styled(Stack)`
    padding: 20px 24px 20px;
    flex: 1;
    margin: 0;
`;
